import { PlusIcon } from 'assets/icons';
import AmountFilterPopoverPanel from 'components/custom-amount-filter/AmountFilterPopoverPanel';
import { AmountFilter } from 'components/custom-amount-filter/CustomAmountFilter';
import DropdownPopoverPanel from 'components/dropdown-with-search/DropdownPopoverPanel';
import { AmountFilterOperation } from 'constants/common';
import React, { FC, useState } from 'react';
import { VoidFn } from 'types/baseTypes';

interface MoreFilterPopoverPanelProps {
  data: any[];
  dataKey: string;
  selectedDraftArray: string[];
  setSelectedDraftArray: (selectedDraftArray: string[]) => void;
  setSelectedArray: (selectedArray: string[]) => void;
  searchText?: string;
  setSearchText?: (searchText: string) => void;
  dataIdKey: string;
  filterPlaceholderText: string;
  filterPlaceholderStyle: string;
  searchPlaceHolderText: string;
  searchInputStyle: string;
  allowSearch: boolean;
  showResultsCount: boolean;
  filterId: string;
  secondaryDataKey: string;
  searchFilterId: string;
  operation: AmountFilterOperation;
  setOperation: (operation: AmountFilterOperation) => void;
  startValue: number;
  setStartValue: (startValue: number) => void;
  endValue: number;
  setEndValue: (endValue: number) => void;
  amountFilter: AmountFilter;
  setAmountFilter: (amountFilter: AmountFilter) => void;
  close: VoidFn;
  externalCompanies: string[];
  setExternalCompanies: (value: string[]) => void;
  externalCompaniesDraft: string[];
  setExternalCompaniesDraft: (value: string[]) => void;
  availableFilterOptions: Array<{ label: string; value: string; show: boolean }>;
  externalCompanyOptions: { id: string; value: string; label: string }[];
  showJobSourceFilter: boolean;
  createdByData: any[];
  createdByDataKey?: string;
  createdBySecondaryDataKey?: string;
  createdByDraft: string[];
  setCreatedByDraft: (value: string[]) => void;
  createdBySearchText?: string;
  setCreatedBySearchText?: (value: string) => void;
  createdByDataIdKey?: string;
  leadSourceData: any[];
  leadSourceDataKey?: string;
  leadSourceDraft: string[];
  setLeadSourceDraft: (value: string[]) => void;
  setLeadSourceSelected: (value: string[]) => void;
  leadSourceDataIdKey?: string;
  setCreatedBySelected: (value: string[]) => void;
  serviceAreaOptions: { id: string; name: string }[];
  serviceAreaDraft: string[];
  setServiceAreaDraft: (arr: string[]) => void;
  selectedServiceAreas: string[];
  setSelectedServiceAreas: (arr: string[]) => void;
  serviceAreaSearch: string;
  setServiceAreaSearch: (s: string) => void;
}

const MoreFilterPopoverPanel: FC<MoreFilterPopoverPanelProps> = ({
  data,
  dataKey,
  selectedDraftArray,
  setSelectedDraftArray,
  setSelectedArray,
  searchText,
  setSearchText,
  dataIdKey,
  filterPlaceholderText,
  filterPlaceholderStyle,
  searchPlaceHolderText,
  searchInputStyle,
  allowSearch,
  showResultsCount,
  filterId,
  secondaryDataKey,
  searchFilterId,
  close,
  operation,
  setOperation,
  startValue,
  endValue,
  setStartValue,
  setEndValue,
  amountFilter,
  setAmountFilter,
  setExternalCompanies,
  externalCompaniesDraft,
  setExternalCompaniesDraft,
  availableFilterOptions,
  externalCompanyOptions,
  showJobSourceFilter,
  createdByData,
  createdByDataKey,
  createdBySecondaryDataKey,
  createdByDraft,
  setCreatedByDraft,
  setCreatedBySelected,
  createdBySearchText,
  setCreatedBySearchText,
  createdByDataIdKey,
  leadSourceData,
  leadSourceDataKey,
  leadSourceDraft,
  setLeadSourceDraft,
  setLeadSourceSelected,
  leadSourceDataIdKey,
  serviceAreaOptions,
  serviceAreaDraft,
  setServiceAreaDraft,
  setSelectedServiceAreas,
  serviceAreaSearch,
  setServiceAreaSearch
}) => {
  const [filterOption, setFilterOption] = useState(null);

  return (
    <div
      className={
        (open ? 'block ' : 'hidden ') + 'z-50 pt-4  list-none rounded-md border border-[#ACB5BD] w-fit min-w-[208px]'
      }
      style={{
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'
      }}>
      {!filterOption && (
        <div className="flex flex-col gap-y-4 px-3 pb-2.5">
          {availableFilterOptions.map((option, index) => (
            <div
              className="flex cursor-pointer gap-x-3"
              key={`more-filter-option-${index + 1}`}
              onClick={() => setFilterOption(option.value)}>
              <PlusIcon className="shrink-0" />
              <div className="text-sbase font-semibold text-primaryText">{option.label}</div>
            </div>
          ))}
        </div>
      )}
      {filterOption === 'customer' && (
        <DropdownPopoverPanel
          data={data}
          dataKey={dataKey}
          selectedDraftArray={selectedDraftArray}
          setSelectedDraftArray={setSelectedDraftArray}
          setSelectedArray={setSelectedArray}
          searchText={searchText}
          setSearchText={setSearchText}
          dataIdKey={dataIdKey}
          filterPlaceholderText={filterPlaceholderText}
          filterPlaceholderStyle={filterPlaceholderStyle}
          searchPlaceHolderText={searchPlaceHolderText}
          searchInputStyle={searchInputStyle}
          allowSearch={allowSearch}
          showResultsCount={showResultsCount}
          filterId={filterId}
          secondaryDataKey={secondaryDataKey}
          searchFilterId={searchFilterId}
          close={close}
        />
      )}
      {filterOption === 'amount' && (
        <AmountFilterPopoverPanel
          operation={operation}
          setOperation={setOperation}
          startValue={startValue}
          setStartValue={setStartValue}
          endValue={endValue}
          setEndValue={setEndValue}
          amountFilter={amountFilter}
          setAmountFilter={setAmountFilter}
          close={close}
        />
      )}
      {filterOption === 'externalCompany' && showJobSourceFilter && (
        <DropdownPopoverPanel
          data={externalCompanyOptions}
          dataKey="label"
          selectedDraftArray={externalCompaniesDraft}
          setSelectedDraftArray={setExternalCompaniesDraft}
          setSelectedArray={setExternalCompanies}
          dataIdKey="value"
          filterPlaceholderText="Filter by external company"
          filterPlaceholderStyle={filterPlaceholderStyle}
          searchPlaceHolderText=""
          searchInputStyle={searchInputStyle}
          allowSearch={false}
          showResultsCount={showResultsCount}
          filterId="jobs-external-company-filter"
          close={close}
        />
      )}
      {filterOption === 'createdBy' && (
        <DropdownPopoverPanel
          data={createdByData}
          dataKey={createdByDataKey || 'firstName'}
          secondaryDataKey={createdBySecondaryDataKey || 'lastName'}
          selectedDraftArray={createdByDraft}
          setSelectedDraftArray={setCreatedByDraft}
          setSelectedArray={setCreatedBySelected}
          searchText={createdBySearchText}
          setSearchText={setCreatedBySearchText}
          dataIdKey={createdByDataIdKey || 'merchantId'}
          filterPlaceholderText={'Filter by merchants'}
          searchPlaceHolderText={'Search merchant names'}
          allowSearch={true}
          showResultsCount={true}
          filterId={'jobs-createdby-filter'}
          close={close}
        />
      )}
      {filterOption === 'leadSource' && showJobSourceFilter && (
        <DropdownPopoverPanel
          data={leadSourceData}
          dataKey={leadSourceDataKey || 'label'}
          selectedDraftArray={leadSourceDraft}
          setSelectedDraftArray={setLeadSourceDraft}
          setSelectedArray={setLeadSourceSelected}
          dataIdKey={leadSourceDataIdKey || 'value'}
          filterPlaceholderText={'Filter by lead source'}
          allowSearch={false}
          showResultsCount={true}
          filterId={'jobs-lead-source-filter'}
          close={close}
        />
      )}
      {filterOption === 'serviceArea' && (
        <DropdownPopoverPanel
          data={serviceAreaOptions}
          dataKey="name"
          dataIdKey="id"
          selectedDraftArray={serviceAreaDraft}
          setSelectedDraftArray={setServiceAreaDraft}
          setSelectedArray={setSelectedServiceAreas}
          searchText={serviceAreaSearch}
          setSearchText={setServiceAreaSearch}
          filterPlaceholderText="Filter by service area"
          searchPlaceHolderText="Search service area"
          allowSearch={true}
          showResultsCount={true}
          filterId="jobs-service-area-filter"
          close={close}
        />
      )}
    </div>
  );
};

export default MoreFilterPopoverPanel;
